export class ContactStatusManager {
    public static CONTACT_MESSAGE_SENDED = 'CONTACT_MESSAGE_SENDED'

}
